<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="标题:">
                        <el-input v-model="table.where.name" placeholder="请输入标题" clearable />
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="排序:">
                        <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:integralgoodsformat:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-restore"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:integralgoodsformat:add')">添加
                </el-button>
                <!-- <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:integralgoodsformat:dall')">批量删除
                </el-button> -->
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row  row-key="name" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />
                    <el-table-column prop="name" label="标题" sortable="custom" show-overflow-tooltip min-width="120" />
                    <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="120" />
                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:integralgoodsformat:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此规格预设吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:integralgoodsformat:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改规格预设':'添加规格预设'" :visible.sync="showEdit" width="800px"
            :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false" @close="closeDialog">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                <el-form-item label="规格标题:" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入标题" clearable />
                </el-form-item>
                <el-form-item label="规格名称:" prop="value">
                    <el-input placeholder="请输入标题,例如:尺寸,颜色等" v-model="title" style="width: 85%;"></el-input><el-button @click.prevent="formatTitleAdd()">添加</el-button>
                </el-form-item>
                <div v-for="(item,index) in editForm.children " :key="index" style="margin-bottom: 10px;">
                    <el-form-item :label="item.name" prop="value">
                        <el-input placeholder="请输入规格值,例如:红色,蓝色等" v-model="item.temp_value_title" style="width: 75%;"></el-input><el-button @click.prevent="formatValueTitleAdd(index)">添加</el-button><el-button type="danger" @click.prevent="formatValueTitleDelete(index)">删除</el-button>
                        <el-tag
                          v-for="(tag,tab_index) in item.children"
                          :key="tab_index"
                          closable
                           @close="deleteTips(index,tab_index)">
                          {{tag.name}}
                        </el-tag>
                    </el-form-item>
                </div>
                <el-form-item label="排序:" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";


    export default {
        name: "SysstoreGoodsFormat",
        components: {},
        data() {
            return {
                table: {
                    url: '/integral/integralGoodsFormat/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    children:[]
                }, // 表单数据
                editFormTemp: {
                    children:[]
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                options:[],
                title:'',
                editRules: { // 表单验证规则
                    name: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }],
                    industry_id: [{
                        required: true,
                        message: '请选择行业',
                        trigger: 'blur'
                    }],
                    shop_id: [{
                        required: true,
                        message: '请选择店铺',
                        trigger: 'blur'
                    }],
                    
                },
                store_shop_management_list:[]
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {
        },
        methods: {
            /* 删除规格值*/
            deleteTips(index,tag_index){
                this.editForm.children[index].children.splice(tag_index,1);
            },
            /* 删除规格组*/
            formatValueTitleDelete(index){
                this.editForm.children.splice(index,1);
            },
            /* 添加规格值*/
            formatValueTitleAdd(index){
                if(this.editForm.children[index].temp_value_title !== ''){
                    let temp_data = {
                        name:this.editForm.children[index].temp_value_title,
                    }
                    this.editForm.children[index].children.push(temp_data);
                    this.editForm.children[index].temp_value_title = '';
                }
            },
            /* 添加规格名称*/
            formatTitleAdd(){
                if(this.title !== ''){
                    let temp_data = {
                        name:this.title,
                        temp_value_title:'',
                        children:[]
                    }
                    this.editForm.children.push(temp_data);
                    this.title = '';
                }
            },
            
            /* 新增*/
            add(){
                this.$http.post('/store/storeIndustry/allList').then(res => {
                    if (res.data.code === 0) {
                        console.log(this.editForm)
                        this.showEdit = true;
                        setTimeout(() => {
                            this.options = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/integral/integralGoodsFormat/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.add();
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        if(Array.isArray(this.editForm.industry_id)){
                            this.editForm.industry_id = this.editForm.industry_id[this.editForm.industry_id.length-1];
                        }
                        this.$http.post('/integral/integralGoodsFormat/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的规格预设吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/integral/integralGoodsFormat/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/integral/integralGoodsFormat/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids = this.choose.map(d => d.id)
                if (ids.length == 0) {
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/user/UserMail/exportExcel", {
                        id: ids
                    })
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
          

        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>